import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom"; // Importamos o useLocation
import Loader from "../../components/Loader";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useSelector((state) => state.user);
  const location = useLocation(); // Captura a URL atual

  if (loading) {
    return <Loader />;
  }

  // SÓ redireciona se o usuário tentar acessar a rota raiz "/"
  if (location.pathname === "/") {
    if (user?.id && user?.nivel === "Caixa") {
      return <Navigate to="/faturacao/emitir-documento/" replace />;
    } 
    
    if (user?.id && user?.nivel === "Admin") {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Se ele não estiver na raiz, ou se for outro nível, renderiza a página normal
  return children;
};

export default ProtectedRoute;